// extracted by mini-css-extract-plugin
export default {"yordex-theme":"theme-provider_yordex-theme__gc5tb"};